export function createProgram(gl:WebGLRenderingContext,vertexShaderSource:string,fragmentShaderSource:string) {
    const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource);
    const fragmentShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShaderSource);
    if (!vertexShader || !fragmentShader) throw new Error('Failed to create shaders');
    let program = gl.createProgram();
    if (!program) throw new Error('Failed to create WebGL program');
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    return program;
}
function createShader(gl:WebGLRenderingContext, type:number, source:string) {
    const shader = gl.createShader(type);
    if (!shader) throw new Error('Failed to create shader');
    gl.shaderSource(shader,source);
    gl.compileShader(shader);
    return shader;
}
